import CoreLayout from './CoreLayout'
import { connect } from 'react-redux'
import { configLoad } from '../../store/config'
import localize from '../../higherOrderComponents/localize'

const mapStateToProps = (state, ownProps) => {
  return { userInfo: state.userInfo }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    loadConfig: () => {
      dispatch(configLoad())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(localize(CoreLayout))



// WEBPACK FOOTER //
// ./src/components/CoreLayout/index.js